import React, { useEffect } from 'react'
import { compose, graphql } from 'react-apollo'

// Constants
import { Constants } from '@sukiai/components'
import { SET_AGENT_SIZE, SET_AGENT_POSITION } from '../apollo/actions'
import { OOBE_LAYOUT_UPDATE } from '../constants/pubSub.events'
import { EMPTY_OBJECT } from '../constants/base.constants'

// Utils
import pubSub from '../lib/util/pubSub'
import { isAmwellTheme } from '../lib'

// Components
import GettingStarted from '../components/gettingStarted'

const { AGENT } = Constants

const HomeContainer = (props) => {
  const setAgentLayout = ({ disabled = true } = EMPTY_OBJECT) => {
    const { setAgentSize, setAgentPosition } = props
    setAgentSize(AGENT.SIZE.LARGE)
    const agentPosition = disabled
      ? AGENT.POSITION.CENTER
      : AGENT.POSITION.MIDDLE_LEFT
    setAgentPosition(agentPosition)
  }

  useEffect(() => {
    setAgentLayout()
    const subscription = pubSub.subscribe(OOBE_LAYOUT_UPDATE, setAgentLayout)
    return () => {
      subscription.unsubscribe()
    }
  }, [])

  if (isAmwellTheme()) {
    return null
  }
  return <GettingStarted />
}

export default compose(
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: (agentSize) =>
        mutate({
          variables: { agentSize }
        })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: (agentPosition) =>
        mutate({
          variables: { agentPosition }
        })
    })
  })
)(HomeContainer)
